import React from 'react'
import Layout from '../layout/layout'
import { Row, Col } from 'react-bootstrap'
import styles from './staticpages.module.css'

const PrivacyPolicy: React.FC = () => {
  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto">
          <Row>
            <Col>
              <h1 className="pageTitle mb-4">Privacy Policy</h1>
            </Col>
          </Row>
          <Row>
            <Col className={styles.staticPage}>
              <p>
                This Privacy Policy describes how your personal information is
                collected, used, and shared when you visit or make a purchase
                from <a href="https://bigmochi.com">https://bigmochi.com</a>
                {'   '}(the “Site”).
              </p>
              <h5>
                <b>Personal information we collect </b>
              </h5>
              <p>
                When you visit the Site, we automatically collect certain
                information about your device, including information about your
                web browser, IP address, time zone, and some of the cookies that
                are installed on your device. Additionally, as you browse the
                Site, we collect information about the individual web pages or
                products that you view, what websites or search terms referred
                you to the Site, and information about how you interact with the
                Site. We refer to this automatically-collected information as
                “Device Information”.
              </p>
              <p>
                We collect Device Information using the following technologies:
                <ul>
                  <li>
                    “Cookies” are data files that are placed on your device or
                    computer and often include an anonymous unique identifier.
                    For more information about cookies, and how to disable
                    cookies, visit{' '}
                    <a href="http://www.allaboutcookies.org">
                      http://www.allaboutcookies.org
                    </a>
                    .{' '}
                  </li>
                  <li>
                    “Web beacons”, “tags”, and “pixels” are electronic files
                    used to record information about how you browse the Site.{' '}
                  </li>
                </ul>
              </p>
              <p>
                Additionally when you make a purchase or attempt to make a
                purchase through the Site, we collect certain information from
                you, including your name, billing address, shipping address,
                payment information (including credit card numbers), email
                address, and phone number. We refer to this information as
                “Order Information”.
              </p>
              <p>
                When we talk about “Personal Information” in this Privacy
                Policy, we are talking both about Device Information and Order
                Information.
              </p>
              <h5>
                <b>How do we use your personal information? </b>
              </h5>
              <p>
                We use the Order Information that we collect generally to
                fulfill any orders placed through the Site (including processing
                your payment information, arranging for shipping, and providing
                you with invoices and/or order confirmations). Additionally, we
                use this Order Information to:
                <ul>
                  <li>Communicate with you;</li>
                  <li>Screen our orders for potential risk or fraud; and</li>
                  <li>
                    When in line with the preferences you have shared with us,
                    provide you with information or advertising relating to our
                    products or services.
                  </li>
                </ul>
              </p>
              <p>
                We use the Device Information that we collect to help us screen
                for potential risk and fraud (in particular, your IP address),
                and more generally to improve and optimize our Site (for
                example, by generating analytics about how our customers browse
                and interact with the Site, and to assess the success of our
                marketing and advertising campaigns).
              </p>
              <h5>
                <b>Sharing your personal Information </b>
              </h5>
              <p>
                We share your Personal Information with third parties to help us
                use your Personal Information, as described above. For example,
                we use Google Analytics to help us understand how our customers
                use the Site -- you can read more about how Google uses your
                Personal Information here: {'   '}
                <a href="https://www.google.com/intl/en/policies/privacy/">
                  https://www.google.com/intl/en/policies/privacy/
                </a>
                . You can also opt-out of Google Analytics here:
                <a href=" https://tools.google.com/dlpage/gaoptout">
                  {'   '} https://tools.google.com/dlpage/gaoptout
                </a>
                .
              </p>
              <p>
                Finally, we may also share your Personal Information to comply
                with applicable laws and regulations, to respond to a subpoena,
                search warrant or other lawful request for information we
                receive, or to otherwise protect our rights.
              </p>
              <h5>
                <b>Behavioural advertising </b>
              </h5>
              <p>
                As described above, we use your Personal Information to provide
                you with targeted advertisements or marketing communications we
                believe may be of interest to you. For more information about
                how targeted advertising works, you can visit the Network
                Advertising Initiative’s (“NAI”) educational page at{' '}
                <a href="http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work">
                  http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work
                </a>
              </p>
              <p>
                You can opt out of targeted advertising by using the links
                below:
                <ul>
                  <li>
                    Facebook:
                    <a href="https://www.facebook.com/settings/?tab=ads">
                      {' '}
                      https://www.facebook.com/settings/?tab=ads
                    </a>{' '}
                  </li>
                  <li>
                    Google:{' '}
                    <a href="https://www.google.com/settings/ads/anonymous">
                      https://www.google.com/settings/ads/anonymous
                    </a>{' '}
                  </li>
                  <li>
                    Bing:
                    <a href="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads">
                      https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads
                    </a>
                  </li>
                </ul>
              </p>
              <p>
                Additionally, you can opt out of some of these services by
                visiting the Digital Advertising Alliance’s opt-out portal at:
                <a href="http://optout.aboutads.info/">
                  http://optout.aboutads.info/
                </a>
                .
              </p>
              <h5>
                <b>Do not track </b>
              </h5>
              <p>
                Please note that we do not alter our Site’s data collection and
                use practices when we see a Do Not Track signal from your
                browser.
              </p>

              <h5>
                <b>Data retention </b>
              </h5>
              <p>
                When you place an order through the Site, we will maintain your
                Order Information for our records unless and until you ask us to
                delete this information.
              </p>

              <h5>
                <b>Changes </b>
              </h5>
              <p>
                We may update this privacy policy from time to time in order to
                reflect, for example, changes to our practices or for other
                operational, legal or regulatory reasons.
              </p>

              <h5>
                <b>Minors </b>
              </h5>
              <p>
                The Site is not intended for individuals under the age of 18
                years.
              </p>

              <h5>
                <b>Contact us </b>
              </h5>
              <p>
                For more information about our privacy practices, if you have
                questions, or if you would like to make a complaint, please
                contact us by e‑mail at{' '}
                <a href="mailto:store@bigmochi.com ">store@bigmochi.com</a> or
                by mail using the details provided below:
              </p>

              <p>
                BigMochi Financial Pte. Ltd. <br />
                48 Toh Yi Road, 596517, Singapore.
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout>
  )
}

export default PrivacyPolicy
